/**
 * Custom props for the payment image component
 */
interface Props {
    /**
     * The type of the payment method
     */
    type: string;
}

/**
 * Returns an image according to the type of a payment method
 */
export const PaymentSteps = ({ type }: Props) => {
    /**
     * Reads the type of the payment method and returns an image component
     */
    const paymentImage = () => {
        if(!type) {
            return <></>
        };
        const payment = type.toLowerCase();
        if (payment.includes("oxxo")) {
            return (
                <ul style={{ listStyle: "none" }}>
                    <li>1. Seleccionar OXXO Pay como método de pago.</li>
                    <li>2. Confirmar la transacción y ver el resumen del pedido.</li>
                    <li>3. El cliente recibirá un código de 14 dígitos.</li>
                    <li>4. El código se debe de presentar con el cajero de una tienda OXXO.</li>
                    <li>5. Pagar el monto correspondiente.</li>
                    <li>6. El cliente recibe una notificación de confirmación del pago.</li>
                </ul>
            )
        }
        else if (payment.includes("mastercard") || payment.includes("visa") || payment.includes("crédito")) {
            return (
                <ul style={{ listStyle: "none" }}>
                    <li>1. Seleccionar Visa o Mastercard como método de pago.</li>
                    <li>2. Ingresar los datos correspondientes de la tarjeta.</li>
                    <li>3. Confirmar la transacción y ver el resumen del pedido.</li>
                </ul>
            )
        }
        else if (payment.includes("paypal")) {
            return (
                <ul style={{ listStyle: "none" }}>
                    <li>1. Seleccionar Paypal como método de pago.</li>
                    <li>2. Iniciar sesión con su cuenta de Paypal y seleccionar la tarjeta deseada.</li>
                    <li>3. Confirmar la transacción y ver el resumen del pedido.</li>
                </ul>
            )
        }
        else if (payment.includes("mercado")) {
            return (
                <ul style={{ listStyle: "none" }}>
                    <li>1. Seleccionar Mercado Pago como método de pago.</li>
                    <li>2. Iniciar sesión con su cuenta de Mercado Pago y seleccionar la tarjeta deseada.</li>
                    <li>3. Confirmar la transacción y ver el resumen del pedido.</li>
                </ul>
            )
        }
        else if (payment.includes("transferencia")) {
            return (
                <ul style={{ listStyle: "none" }}>
                    <li>1. Seleccionar Transferencia bancaria como método de pago.</li>
                    <li>2. Al cliente se le muestran los datos necesarios para realizar una transferencia bancaria.</li>
                    <li>3. Una vez realizada la transferencia, debe adjuntar la foto del comprobante.</li>
                    <li>4. El vendedor verifica el pago y realiza el envío.</li>
                </ul>
            )
        }
        return <></>
    }

    return (
        paymentImage()
    )
}
